export default __webpack_public_path__ + "static/media/board.fb391818.svg";